import { dashboardConstants } from "../actions/constants/dashboardConstants";
import { request,success,failure } from "@/utils/constants"

export const getDashboardReducer = (state = {}, action: any) => {
    switch (action.type) {
        case dashboardConstants.getDashboardRequest:
            return {
                ...request
            }
        case dashboardConstants.getDashboardSuccess:
            return {
                ...success,
                data: action.payload,
            }
        case dashboardConstants.getDashboardFailure:
            return {
                ...failure,
            }
        default:
            return state;
    }
}